export default "__VITE_PUBLIC_ASSET__5b458913__"